export default class GoodiesInfo {

    constructor(data) {
        //console.log('goodies info contructor', data);
        this.data = data;
    }

    get level(){
        return this.data && this.data.hasOwnProperty('level') ? this.data.level : null;
    }

    get levelAdded(){
        return this.data && this.data.hasOwnProperty('levelAdded') ? this.data.levelAdded : null;
    }

    get levelIndex(){
        return this.data && this.data.hasOwnProperty('index') ? this.data.index : null;
    }

    get autoRemovedMsg(){
        return this.data && this.data.hasOwnProperty('autoRemoved') ? this.data.autoRemoved : null;
    }

    get message(){
        return this.data && this.data.hasOwnProperty('message') ? this.data.message : null;
    }

    get addToCartError(){
        return this.data && this.data.hasOwnProperty('addToCartError') ? this.data.addToCartError : null;
    }

    get addToCartWarning(){
        return this.data && this.data.hasOwnProperty('addToCartWarning') ? this.data.addToCartWarning : null;
    }

    get summaryDetail(){
        return this.data && this.data.hasOwnProperty('summaryDetail') ? this.data.summaryDetail : null;
    }

    get showSummary(){
        return this.data && this.data.hasOwnProperty('showSummary') ? this.data.showSummary : null;
    }

    /**
     * Allows multiple products to be selected 
     */
    get allowMultiple(){
        return this.data && this.data.hasOwnProperty('multiple') ? this.data.multiple : null;
    }

    /**
     * Is category mode
     */
    get isCategoryMode(){
        return this.data && this.data.hasOwnProperty('isCategory') ? this.data.isCategory : null;
    }

    get valueToUse(){
        return this.data && this.data.hasOwnProperty('valueToUse') ? this.data.valueToUse : 0;
    }

    get valueUsed(){
        return this.data && this.data.hasOwnProperty('valueUsed') ? this.data.valueUsed : 0;
    }

    get valueRemaining(){
        return this.valueToUse - this.valueUsed;
    }

}